import React from 'react'

import PropTypes from 'prop-types'

import {useUserConsents} from '@s-ui/consents'
import AtomButton, {atomButtonDesigns, atomButtonSizes} from '@s-ui/react-atom-button'
import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import SUIContext from '@s-ui/react-context'
import PrimitiveTypography, {
  primitiveTypographyDesign,
  primitiveTypographyFontSize,
  primitiveTypographyFontWeight
} from '@s-ui/react-primitive-typography'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import IconAngleRight from '@adv-mt/mt-svg-icons/lib/ChevronRight.js'
import IconPeriodForwardOutline from '@adv-mt/mt-svg-icons/lib/PeriodForwardOutline.js'

import NavigationLastAdsSearchesModal from './navigation-last-ads-searches-modal.js'
import {useLastAdsSearches} from './useLastAdsSearches.js'

const BASE_CLASS = 'mt-NavigationLastAdsSearches'

const NavigationLastAdsSearches = ({domain, i18n, lastAdsSearches = [], onOpenModal}) => {
  const config = domain.get('config')

  const {
    CONSENTS: {LAST_ADS_SEARCH: lastAdsSearchRequiredConsents}
  } = config.get('COMMON')

  const isMobile = config.get('isMobile')
  const isTablet = config.get('isTablet')
  const isDesktopOrWider = useMediaQuery(useMediaQueryBreakpoints.lg, {
    defaultMatches: !isMobile && !isTablet
  })

  const hasConsentsForLastAdsSearch = useUserConsents(lastAdsSearchRequiredConsents)

  const hasItems = lastAdsSearches.length > 0

  return (
    <>
      {hasConsentsForLastAdsSearch && hasItems && (
        <>
          {isDesktopOrWider ? (
            <AtomButton
              onClick={onOpenModal}
              size={atomButtonSizes.MEDIUM}
              design={atomButtonDesigns.LINK}
              leftIcon={<IconPeriodForwardOutline size={ATOM_ICON_SIZES.medium} />}
              isFitted
              className={`${BASE_CLASS}-button`}
              data-testid="last-ads-searches-button"
            >
              {i18n.t('NAVIGATION_LAST_SEARCHES')}
            </AtomButton>
          ) : (
            <div onClick={onOpenModal} className={`${BASE_CLASS}-mobileButton`}>
              <IconPeriodForwardOutline size={ATOM_ICON_SIZES.medium} />
              <PrimitiveTypography
                as="span"
                design={primitiveTypographyDesign.BODY_1}
                fontSize={primitiveTypographyFontSize.L}
                fontWeight={primitiveTypographyFontWeight.SEMI_BOLD}
              >
                {i18n.t('NAVIGATION_LAST_SEARCHES')}
              </PrimitiveTypography>
              <IconAngleRight size={ATOM_ICON_SIZES.medium} className={`${BASE_CLASS}-mobileButton-rightIcon`} />
            </div>
          )}
        </>
      )}
    </>
  )
}

NavigationLastAdsSearches.displayName = 'NavigationLastAdsSearches'
NavigationLastAdsSearches.propTypes = {
  domain: PropTypes.object.isRequired,
  i18n: PropTypes.object.isRequired,
  lastAdsSearches: PropTypes.array,
  onOpenModal: PropTypes.func
}

const MemoNavigationLastAdsSearches = React.memo(NavigationLastAdsSearches)

export {NavigationLastAdsSearchesModal, useLastAdsSearches}

export default SUIContext.wrapper(MemoNavigationLastAdsSearches, 'NavigationLastAdsSearches')
